import { h, resolveDynamicComponent } from 'vue'
import { registerFieldType } from './fieldRegistry'

import {
	ElInput,
	ElInputNumber,
	ElSelect,
	ElSelectV2,
	ElOption,
	ElCascader,
	ElTreeSelect,
	ElRadio,
	ElRadioGroup,
	ElRadioButton,
	ElCheckbox,
	ElCheckboxGroup,
	ElCheckboxButton,
	ElSwitch,
	ElRate,
	ElSlider,
	ElDatePicker,
	ElTimePicker,
	ElTimeSelect,
	ElAutocomplete,
	ElColorPicker
} from 'element-plus'

// 你已有组件
import EditorVue from '../components/Editor/Index.vue'
import IconSelectVue from '../components/IconSelect/Index.vue'
import UploadFileVue from '../components/UploadFile/Index.vue'
import UploadImageVue from '../components/UploadImage/Index.vue'
import UploadAvatarVue from '../components/UploadAvatar/Index.vue'
import AutoInputTagVue from '../components/AutoInputTag/Index.vue'
import VuDateRange from '../components/DateRange/Index.vue'
import VuTimeRange from '../components/TimeRange/Index.vue'

export function registerAllFields() {

	/* ========== 基础输入 ========== */

	registerFieldType('input', {
		component: ElInput,
		getProps: f => ({
			placeholder: `请输入${f.label}`
		})
	})

	registerFieldType('number', {
		component: ElInputNumber,
		getProps: f => ({
			style: 'width:100%',
			placeholder: `请输入${f.label}`
		})
	})

	registerFieldType('autocomplete', {
		component: ElAutocomplete,
		getProps: f => ({
			placeholder: `请输入${f.label}`
		})
	})

	registerFieldType('colorpicker', {
		component: ElColorPicker
	})

	/* ========== 选择类 ========== */

	registerFieldType('select', {
		component: ElSelect,
		getProps: f => ({
			placeholder: `请选择${f.label}`
		}),
		getSlots: f => ({
			default: () =>
				f.options?.map(opt => h(ElOption, opt))
		})
	})

	registerFieldType('selectv2', {
		component: ElSelectV2,
		getProps: f => ({
			options: f.options,
			placeholder: `请选择${f.label}`
		})
	})

	registerFieldType('cascader', {
		component: ElCascader,
		getProps: f => ({
			options: f.options,
			placeholder: `请选择${f.label}`
		})
	})

	registerFieldType('treeselect', {
		component: ElTreeSelect,
		getProps: f => ({
			data: f.options,
			placeholder: `请选择${f.label}`
		})
	})

	/* ========== 单选 / 多选 ========== */

	registerFieldType('radio', {
		component: ElRadioGroup,
		getSlots: f => ({
			default: () =>
				f.options?.map(opt =>
					h(ElRadio, {
						...opt,
						label: opt.value
					}, () => opt.label)
				)
		})
	})

	registerFieldType('radiobutton', {
		component: ElRadioGroup,
		getSlots: f => ({
			default: () =>
				f.options?.map(opt =>
					h(ElRadioButton, {
						...opt,
						label: opt.value
					}, () => opt.label)
				)
		})
	})

	registerFieldType('checkbox', {
		component: ElCheckboxGroup,
		getSlots: f => ({
			default: () =>
				f.options?.map(opt =>
					h(ElCheckbox, {
						...opt,
						label: opt.value
					}, () => opt.label)
				)
		})
	})

	registerFieldType('checkboxbutton', {
		component: ElCheckboxGroup,
		getSlots: f => ({
			default: () =>
				f.options?.map(opt =>
					h(ElCheckboxButton, {
						...opt,
						label: opt.value
					}, () => opt.label)
				)
		})
	})

	/* ========== 开关 / 评分 / 滑块 ========== */

	registerFieldType('switch', {
		component: ElSwitch
	})
	registerFieldType('rate', {
		component: ElRate
	})
	registerFieldType('slider', {
		component: ElSlider
	})

	/* ========== 日期时间 ========== */

	;
	['date', 'datetime', 'daterange', 'datetimerange'].forEach(type => {
		registerFieldType(type, {
			component: ElDatePicker,
			getProps: f => ({
				type,
				style: 'width:100%',
				placeholder: `请选择${f.label}`
			})
		})
	})

	registerFieldType('timepicker', {
		component: ElTimePicker,
		getProps: f => ({
			style: 'width:100%',
			placeholder: `请选择${f.label}`
		})
	})

	registerFieldType('timeselect', {
		component: ElTimeSelect,
		getProps: f => ({
			style: 'width:100%',
			placeholder: `请选择${f.label}`
		})
	})

	registerFieldType('daterange-pro', {
		component: VuDateRange
	})

	registerFieldType('timerange', {
		component: VuTimeRange
	})

	/* ========== 上传 / 富文本 / 特殊组件 ========== */

	registerFieldType('editor', {
		component: EditorVue,
		getProps: f => ({
			placeholder: `请输入${f.label}`
		})
	})

	registerFieldType('iconselect', {
		component: IconSelectVue,
		getProps: f => ({
			placeholder: `请选择${f.label}`
		})
	})

	registerFieldType('autotaginput', {
		component: AutoInputTagVue,
		getProps: f => ({
			placeholder: `请输入${f.label}`
		})
	})

	registerFieldType('avatar', {
		component: UploadAvatarVue
	})
	registerFieldType('image', {
		component: UploadImageVue
	})
	registerFieldType('file', {
		component: UploadFileVue
	})
}